import {
   ComponentRef,
   Directive,
   Input,
   OnChanges,
   OnDestroy,
   SimpleChanges,
   TemplateRef,
   ViewContainerRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { selectLastError } from 'src/app/common-components/errors/state/error-message.selectors';
import { InternalServerErrorComponent } from './internal-server-error/internal-server-error.component';
import { NotFoundComponent } from './not-found/not-found.component';

@Directive({
    selector: '[ndtErrorPage]',
    standalone: false
})
export class ErrorPageDirective implements OnChanges, OnDestroy {
   @Input('ndtErrorPage') showContent: boolean;

   @Input('ndtErrorPageMessage') message: string;

   @Input('ndtErrorPageEntityName') entityName: string;

   private componentRef: ComponentRef<NotFoundComponent | InternalServerErrorComponent>;

   constructor(
      private templateRef: TemplateRef<any>,
      private viewContainerRef: ViewContainerRef,
      private store: Store
   ) {}

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.showContent) {
         this.showAndHideContent(changes.showContent.currentValue);
      }
   }

   ngOnDestroy(): void {
      this.destroyComponentRef();
   }

   private createInternalServerErrorComponent(error): ComponentRef<InternalServerErrorComponent> {
      const ref = this.viewContainerRef.createComponent(InternalServerErrorComponent);
      if (error !== null) {
         ref.instance.error = error;
      }
      return ref;
   }

   private createNotFoundComponent(): ComponentRef<NotFoundComponent> {
      const ref = this.viewContainerRef.createComponent(NotFoundComponent);
      ref.instance.entityName = this.entityName;
      return ref;
   }

   private destroyComponentRef() {
      if (this.componentRef) {
         this.componentRef.destroy();
      }
   }

   private showAndHideContent(showContent: boolean) {
      if (showContent) {
         this.viewContainerRef.createEmbeddedView(this.templateRef);
         this.destroyComponentRef();
      } else if (!showContent) {
         this.store
            .select(selectLastError)
            .pipe(take(1))
            .subscribe((error) => {
               this.viewContainerRef.clear();
               if (error?.status && error.status >= 500 && error.status < 600) {
                  this.componentRef = this.createInternalServerErrorComponent(error);
               } else {
                  this.componentRef = this.createNotFoundComponent();
               }

               if (this.message) {
                  this.componentRef.instance.message = this.message;
               }
            });
      }
   }
}
